
let appRoot = process.env.VUE_APP_ROOT_URL;

let Globals = {
    appRoot,
    apiUrl: process.env.VUE_APP_API_URL,//"https://localhost/api",
    stitchesPerInch: 18,
    stitchMotifMinSpacing: 1, //in stitches
    stitchMotifMinSpacingLoad: 12,
    backgroundStitchHeight: 24,
    motifImageFolderUrl: process.env.VUE_APP_MOTIF_URL,//appRoot + "https://assets.needlepaint.com/motifs",
    stitchMotifCurrentSpacing: 0,
    getUniquePMId: function (pmList) {
        let isUnique = false;
        let pmId = 0;
        while (isUnique == false) {
            pmId = Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
            if (pmList.filter((pm) => pm.id == pmId).length == 0) isUnique = true;
        }
        return pmId;
    },
    getProductType: function () {
        let productString;

        const appWrapper = document.getElementById("designerWrapper");
        if (appWrapper != null) {
            productString = appWrapper.dataset.producttype.toLowerCase();
        } else {
            productString = location.href;
        }
        if (productString.indexOf("collar") > -1) {
            return 3;
        } else if (productString.indexOf("key") > -1) {
            return 7;
        }
        else return 2;
    },
    getProductLocation: function () {
        const appWrapper = document.getElementById("designerWrapper");
        if (appWrapper != null) {
            console.log("location data", appWrapper.dataset.location)
            if (appWrapper.dataset.location == "brw") return 2;
        }
        return 1;
    },
    getRootUrl: function () {
        const appWrapper = document.getElementById("designerWrapper");
        if (appWrapper != null) {
            console.log("location data", appWrapper.dataset.location)
            if (appWrapper.dataset.location == "brw") return "https://brewsterbelt.com";
        }
        if (Globals.okitId() != 0) {

            let ptUrlRoot;
            if (this.getFinishStep() == 1) {
                ptUrlRoot = "/needlepoint-kits";
            }
            else {
                switch (this.getProductType()) {
                    case 2:
                        ptUrlRoot = "/needlepoint-belts";
                        break;
                    case 3:
                        ptUrlRoot = "/needlepoint-dog-collars";
                        break;
                    case 7:
                        ptUrlRoot = "/needlepoint-key-fobs";
                        break;
                    default:
                        ptUrlRoot = "/needlepoint-kits";
                        break;
                }
            }
            return appRoot + ptUrlRoot + "/builder-kit-" + Globals.okitId(); //generic url will be redirected (don't have exact slug url here)
        }
        return "https://www.needlepaint.com";
    },
    getFinishStep: function () {
        const appWrapper = document.getElementById("designerWrapper");
        if (appWrapper != null) {
            console.log("finish step from wrapper", appWrapper.dataset.finish)
            if (appWrapper.dataset.finish == "product") return 2;
        }

        if (location.href.indexOf("updatemotifskit") > -1) {
            return 3; //editing motifs for kit - return to admin
        } else if (location.href.indexOf("bcanvas") > -1) {
            return 1; //complete as canvas
        } else if (location.href.indexOf("bproduct") > -1) {
            return 2; //complete as product
        } 
        else return 0; //must choose canvas or product on finish
    },

    showFinishToggle: function () {
        return this.getProductLocation() == 1 && this.getFinishStep() != 3;
    },
    getInitialFinishStep: function (isNewVisitor = true) {
        let finishStep = this.getFinishStep();
        if (this.showFinishToggle() && finishStep == 0 && isNewVisitor) {
            return 1;
        }
        return finishStep;
    },
    isCanvasFinishSelected: function (userProduct) {
        return this.showFinishToggle() && userProduct && userProduct.finishStep == 1;
    },
    getDesignGuid: function () {
        var pGuid;
        const appWrapper = document.getElementById("designerWrapper");
        if (appWrapper != null && appWrapper.dataset.designGuid?.length) {
            pGuid = appWrapper.dataset.designGuid;
        }
        else pGuid = new URL(location.href).searchParams.get("p");

        console.log("Product Guid: ", pGuid);
        return pGuid;

    },
    isModProduct: function () {
        const appWrapper = document.getElementById("designerWrapper");
        if ((appWrapper != null && appWrapper.dataset.bmod?.length) ||
            (location.href.indexOf("bmod") > -1)) {
            return true; //existing product, use product size
        }
        else return false; //new product, must choose size
    },
    kitId: function () {
        if ((location.href.indexOf("updatemotifskit") > -1)) {

            return location.href.substring(location.href.indexOf("updatemotifskit") + ("updatemotifskit").length).replace("#/","") ;
        }
        else return 0; //altering kit available motifs
    },
    okitId: function () {
        if ((location.href.indexOf("okit") > -1)) {
            //console.log("okit:" + location.href.substring(location.href.indexOf("okit") + ("okit").length).replace("#/", ""));
            return location.href.substring(location.href.indexOf("okit") + ("okit").length).replace("#/", "");
        }
        else return 0; //origin kit
    },
    // Admin cart-edit round-trip: NPNET CartEditController.ModifyDesign appends
    // ?cpid={cartProductId}&oid={orderId} to the designer URL when an admin (or
    // signed-in customer) modifies a design from a cart row. These get re-appended
    // to the post-save redirect so CustomDetail loads in cart-edit mode and the
    // Update In Cart button returns the user to /admin/order-detail or /secure/cart.
    // Returns "" when not present (whitelisted external embeds — brewsterbelt.com,
    // Etsy — don't pass these and will be unaffected).
    cartProductId: function () {
        const v = new URL(location.href).searchParams.get("cpid");
        return v && /^\d+$/.test(v) ? v : "";
    },
    adminOrderId: function () {
        const v = new URL(location.href).searchParams.get("oid");
        return v && /^\d+$/.test(v) ? v : "";
    },
    leatherOverhang: function () {//in inches
        if (this.getProductType() == 7) {
            return .75;
        } else if (this.getProductType() == 3) {
            //return .875;
            return .888888889;
        } else {
            return 1;
        }
    },
    safetyMargin: function () {//in inches
        if (this.getProductType() == 7) {
            return .2222222222;
        } else {
            return .5;
        }
    },
    backgroundOffset: function () {//in inches 
        //to deal with belt variations between canvas and product output widths
        //belt canvas is 1 inch wider on each side than the belt product outputs
        if (this.getProductType() == 2) {
            return 1;
        } else {
            return 0;
        }
    },
    maxWidth: function () {//in pixels
        if (this.getProductType() == 7) {
            return 700;
        } else if (this.getProductType() == 3) {
            return 800;
        }
        return 1100;
    },
    openFirstCustomMotif: function () {
        let productMotifs = this.$store.state.productMotifs;
        if ((productMotifs[0].customMotifInputs) && (productMotifs.length > 0))
            this.editMotif(productMotifs[0]);
    },

    checkWidth: function (
        appStore,
        newSizeId = null,
        motif = null,
        existingWidth = 0,
        isModify = true,
    ) {
        if (this.getFinishStep() == 3) return true;
        //keyfob motif size check
        if ((this.getProductType() == 7) && (motif !=null) && (motif.motifWidth > 60)) {
           return false;
        }

        let motifSpacing = (!isModify) ? (this.getProductType() == 7) ? this.stitchMotifMinSpacingLoad/2 : this.stitchMotifMinSpacingLoad : this.stitchMotifMinSpacing;
        let productInfo = appStore.state.productInfo;
        let productMotifs = appStore.state.productMotifs;
        let sizeId = newSizeId ? newSizeId : appStore.state.userProduct.sizeId;

        console.log("motifSpacing:" + motifSpacing);

        let productInchWidth = productInfo.sizes.find(
            (s) => s.sizeId === sizeId
        ).sizeWidth;
        //console.log("productInchWidth: " + productInchWidth);
        let productWidth =
            productInchWidth * this.stitchesPerInch -
            2 * this.stitchesPerInch * this.leatherOverhang();
        //console.log("productWidth:" + productWidth);
        let productSafeWidth = Math.floor(productWidth - (2 * this.stitchesPerInch * this.safetyMargin())); 
        //console.log("productSafeWidth:" + productSafeWidth);
        let motifTotalWidth = 0;
        let motifTotalWidthWithSpacing = 0;
        for (let p of productMotifs) {
            motifTotalWidthWithSpacing += p.motifData.motifWidth + motifSpacing;
            motifTotalWidth += p.motifData.motifWidth;
        }
        let newMotifWidth = motif ? motif.motifWidth : 0;
        motifTotalWidthWithSpacing -= this.stitchMotifMinSpacing;
        //console.log("productMotifs.length:" + productMotifs.length);
        //console.log("motifTotalWidthWithSpacing:" + motifTotalWidthWithSpacing);
        //console.log("motifTotalWidth:" + motifTotalWidth);
        //console.log("existingWidth:" + existingWidth);
        //console.log(motifTotalWidthWithSpacing + newMotifWidth - existingWidth);
        
        let hasRoom =
            motifTotalWidthWithSpacing + newMotifWidth - existingWidth <= productSafeWidth
                ? true
                : false;
        //console.log('isModify: ' + isModify);
        //console.log('hasRoom: ' + hasRoom);
        if ((!isModify) && (!hasRoom)) {
            let pm = appStore.state.productMotifs[appStore.state.productMotifs.length - 1];
            //console.log(pm);
            appStore.dispatch("removeMotifFromProduct", pm);
            console.log('New product. Remove motifs to fit chosen size.');
            this.checkWidth(
                appStore,
                newSizeId,
                motif,
                existingWidth,
                isModify
            )


        } else {
            if (hasRoom) {

                

            let totalMotifs = motif ? 1 : 0;
            totalMotifs += productMotifs.length;
                //console.log("totalMotifs: " + totalMotifs);
                //console.log(productInchWidth * this.stitchesPerInch)
                //console.log("productWidth: " + productWidth);
                //console.log("productSafeWidth: " + productSafeWidth);
                //console.log("motifTotalWidth: " + motifTotalWidth);
                //console.log("newMotifWidth: " + newMotifWidth); 

                //console.log("spacing without floor: " + (productWidth - (motifTotalWidth + newMotifWidth)) / (totalMotifs+1));

                motifTotalWidth += newMotifWidth - existingWidth;
                totalMotifs = (existingWidth == 0) ? totalMotifs : totalMotifs - 1;
                //console.log("motifTotalWidth: " + motifTotalWidth);
                let availableSpacing = Math.floor((productWidth - (motifTotalWidth)) / (totalMotifs + 1));
                if (availableSpacing < (productWidth - productSafeWidth) / 2) {
                    //console.log("spacing without floor - safe: " + (productSafeWidth - (motifTotalWidth + newMotifWidth)) / (totalMotifs-1));
                    this.stitchMotifCurrentSpacing = Math.floor((productSafeWidth - (motifTotalWidth)) / (totalMotifs-1));
                } else {
                    this.stitchMotifCurrentSpacing = availableSpacing;
                }

                appStore.state.userProduct.motifSpacing = this.stitchMotifCurrentSpacing;
                
            //console.log("stitchMotifCurrentSpacing:  " + this.stitchMotifCurrentSpacing); 
            }
            
            return hasRoom;
        }
        
    },
};

export default Globals;
